import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import './styles/list-toolbar.scss';
import Loaders from '@/components/common/Loaders/Loaders.vue';
import Statistic from '@/components/common/Statistic/Statistic.vue';
import Paginator from '@/components/common/Paginator/Paginator.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListToolbar',
  props: {
  state: {
    type: Object as PropType<{ [key: string]: boolean }>,
    default: () => ({})
  },
  statisticDataState: {
    type: Object as PropType<{ [key: string]: boolean }>,
    default: () => ({})
  },
  statistic: {
    type: Object as PropType<{ value: number, label: string, labelSuffix: string }>,
    default: () => ({})
  },
  paginationStart: {
    type: Number,
    default: 0
  },
  elementsPerPage: {
    type: Number,
    default: 20
  },
  isLastPage: {
    type: Boolean,
    default: false
  },
  numberOfElements: {
    type: Number,
    default: 10
  },
  i18nLabel: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;



const isStatisticLoading = computed(() => props.statisticDataState.loading && !props.statisticDataState.fetched);

const isStatisticFetched = computed(() => props.statisticDataState.fetched);

const isStatisticError = computed(() => props.statisticDataState.error);

const isLoading = computed(() => props.state.loading);

const isFetched = computed(() => props.state.fetched);

const isError = computed(() => props.state.error);

return { __sfc: true,props, isStatisticLoading, isStatisticFetched, isStatisticError, isLoading, isFetched, isError, Loaders, Statistic, Paginator }
}

})